// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * - Include link to Jira ticket to clean up the test after it runs
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_GX_POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    HA_GX_PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    HA_IDA_SERP_GOOGLEONETAP: 'HA_IDA_SERP_GOOGLEONETAP',
    HA_NATIVE_ADOPTION_BANNER_SEARCH_UI: 'HA_NATIVE_ADOPTION_BANNER_SEARCH_UI', // https://jira.expedia.biz/browse/VRBOSHOP-4386
    HA_NATIVE_ADOPTION_BANNER_USE_HAS_APP:
        'HA_NATIVE_ADOPTION_BANNER_USE_HAS_APP',
    HA_NATIVE_ADOPTION_BANNER_V2: 'HA_NATIVE_ADOPTION_BANNER_V2',
    HA_NATIVE_ADOPTION_PLACEMENTS_MASTER_SWITCH:
        'HA_NATIVE_ADOPTION_PLACEMENTS_MASTER_SWITCH',
    HA_NATIVE_ADOPTION_PLACEMENT_HEADER: 'HA_NATIVE_ADOPTION_PLACEMENT_HEADER',
    HA_PTA_DATES_AND_NUMBEROFNIGHTSSUMMARY:
        'HA_PTA_SEARCHFORM_datesnumberOfNightsSummary',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    HA_PTA_LANDING_CLADSONSERP: 'HA_PTA_LANDING_CLAdsOnSeRP',
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates',
    HA_PULSE_CLOSE_SAVE_MODAL: 'ha_pulse_close_save_modal', // (41796) https://jira.expedia.biz/browse/FRIENDS-4245
    HA_PULSE_REMOVE_AUTO_SAVE: 'ha_pulse_remove_auto_save',
    HA_PULSE_SELECTABLE_BOARD_TITLE: 'ha_pulse_selectable_board_title', // https://jira.expedia.biz/browse/FRIENDS-4173: cleanup
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MESO_VRBO_DISPLAY_ADS: 'MESO_Vrbo_display_ads',
    VRBO_EG_MAPS_ADOPTION: 'vrbo_eg_maps_adoption_serp', // https://egtnl.prod.expedia.com/experiment/42682
    VRBO_GDPR_OSANO: 'vrbo_gdpr_osano', // https://jira.expedia.biz/browse/VRBOUITK-1394
    VRBO_HEADER_DESKTOP_PERMANENT_MAD_PLACEMENT:
        'Vrbo_Header_Desktop_permanent_MAD_placement',
    VRBO_LANDING_ARIA_ROLES_ON_SEARCHFORM: 'VRBO_LANDING_ARIArolesOnSearchForm',
    VRBO_LANDING_EGUAS_TYPEAHEAD: 'VRBO_LANDING_EGUAS_typeahead', // 41009 Clean up: https://jira.expedia.biz/browse/SHCMP-2356
    VRBO_LANDING_NEARBY_DESTINATIONS: 'VRBO_LANDING_nearbyDestinations_EGReco', // https://jira.expedia.biz/browse/SHCMP-2419
    VRBO_LANDING_PROPERTY_HERO_IMAGES_SELECTION:
        'Vrbo_landing_propertyheroimageselection', // (39320) https://jira.expedia.biz/browse/VGT-9107
    VRBO_LANDING_REMOVE_SERP_HREFLANGS: 'VRBO_LANDING_RemoveSERPHreflangs', // 43618 Clean up: https://jira.expedia.biz/browse/VGT-11054
    VRBO_LANDING_REPLACE_SERP_CANONICALS_WITH_SLPS:
        'VRBO_LANDING_ReplaceSERPCanonicalsWithSLPs', // 43459 https://jira.expedia.biz/browse/VGT-10887
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK:
        'VRBO_LANDING_searchFormDatepickerDayOfWeek', // https://jira.expedia.biz/browse/SHCMP-2231
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT: 'VRBO_LANDING_searchFormDateFormat', // https://jira.expedia.biz/browse/SHCMP-2194
    VRBO_LANDING_SERP_INDEXATION_POLICY_MVP:
        'VRBO_LANDING_SERPIndexationPolicyMVP',
    VRBO_LANDING_UPDATED_BREADCRUMB_SEO_TEST_2:
        'VRBO_LANDING_UpdatedBreadcrumbSEOTest2', // https://jira.expedia.biz/browse/VGT-9705
    VRBO_LANDING_nearbyDestinations_EGReco:
        'VRBO_LANDING_nearbyDestinations_EGReco', // (41309) https://jira.expedia.biz/browse/VGT-10445
    VRBO_MAD_PLACEMENTS_GIVE_A_SHOT_CAMPAIGN_GATE:
        'Vrbo_MAD_placements_Give_a_shot_campaign_gate',
    VRBO_MAD_SERP_PLACEMENT_SURFACE_GATE:
        'Vrbo_MAD_SERP_placement_surface_gate', // https://jira.expedia.biz/browse/WNAT-505
    VRBO_MESO_HOUSE_ADS: 'VRBO_MeSo_HouseAds', // https://jira.expedia.biz/browse/VRBOADS-53
    VRBO_SERP_PRICES_ON_MAP_PINS: 'SERP_prices_on_map_pins_web', // https://jira.expedia.biz/browse/VRBOSHOP-4323
    VRBO_SERP_SEE_MORE_PROMPT: 'VRBO_SERP_SEE_MORE_PROMPT', // https://jira.expedia.biz/browse/VRBOSHOP-3881
    VRBO_STAR_RATING_HEADER_BANNER: 'Vrbo_star_rating_header_banner',
    VRBO_TGA_TRIPBOARDS_THROTTLE: 'VRBO_TGA_TRIPBOARDS_THROTTLE', // https://jira.expedia.biz/browse/TRIPS-5376
    VRBO_TOTAL_PRICE_POSA_PRICE_SUMMARY:
        'Total_Price_POSa_Price_Summary_on_Vrbo',
    VRBO_WEB_APPLIED_FILTERS: 'vrbo_web_applied_filters', // https://jira.expedia.biz/browse/VRBODISCO-2595
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner'
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
